import { Link } from 'react-router-dom'
import { getImageUrl } from '../../utils/imageUrl'
import { productPath } from '../../utils/productUrl'

export function ProductCard({ product, summaryMax = 100 }) {
  const href = product.url_path || productPath(product)
  const title = [product.brand, product.model].filter(Boolean).join(' ')

  return (
    <Link to={href} className="product-card">
      <div className="product-image-container">
        {product.primary_image_url ? (
          <img
            src={getImageUrl(product.primary_image_url)}
            alt={product.name || title}
            className="product-image"
          />
        ) : (
          <div className="product-image-placeholder">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
              <circle cx="8.5" cy="8.5" r="1.5" />
              <polyline points="21 15 16 10 5 21" />
            </svg>
            <span>Intet billede</span>
          </div>
        )}
      </div>
      <div className="product-info">
        <h3>{title}</h3>
        {product.year && <span className="year">{product.year}</span>}
        {summaryMax > 0 && product.summary && (
          <p className="summary">
            {product.summary.length > summaryMax
              ? `${product.summary.substring(0, summaryMax)}…`
              : product.summary}
          </p>
        )}
      </div>
    </Link>
  )
}
